function pointAt(route, idx) {
  const legs = route.get('legs');
  if (idx < 0 || idx >= legs.size) {
    return null;
  }
  const id = legs.get(idx);
  return route.get(id).lastPoint;
}

export default pointAt;
